<template>
  <div :style="charts20Style" class="pbsj">
    <div id="echarts20" :style="charts20Style"></div>
    <div class="tab-switch">
      <span
        v-for="item in tabData"
        :class="[{'current': tabKey==item}]"
        v-text="item"
        :key="item"
        @click="tabSwitch(item);dataChang(item)"
      ></span>
    </div>
  </div>
</template>
<script>
export default {
  name: "echarts20",
  props: {
    charts20Style: {
      type: Object,
      default: () => {
        return { width: "100%", height: "100%", position: "relative" };
      }
    },
    xData20: {
      type: Array,
      default: () => {
        return ["10/12", "10/13", "10/14", "10/15", "10/16", "10/17", "10/18"];
      }
    },
    legendData20: {
      type: Array,
      default: () => {
        return ["早班", "中班", "晚班", "夜班"];
      }
    },
    datagather: {
      type: Array,
      default: () => {
        return [
          [20, 12, 31, 34, 31, 20, 12],
          [30, 22, 41, 44, 41, 10, 22],
          [10, 42, 11, 14, 21, 50, 15],
          [20, 6, 21, 24, 61, 20, 12]
        ];
      }
    }
  },
  data() {
    let tabData = ["日", "周"];
    let endTime = new Date(
      new Date(new Date().toLocaleDateString()).getTime() +
        24 * 60 * 60 * 1000 -
        1
    );
    return {
      tabData: tabData,
      tabKey: tabData[0],
      settime: endTime
    };
  },
  mounted() {
    this.pies();
    // console.log(this.datagather[0]);
  },
//   computed: {
//     tabKey() {
//       return this.tabKey;
//     }
//   },
//   watch: {
//     tabKey(newValue, oldValue) {
// // 　　　　console.log(newValue)
// 　　}
// },
  methods: {
    tabSwitch(item) {
      // console.log(item);
      this.tabKey = item;
      //   this.getGzsjhzList();
    },
    dataChang(val) {
      this.$emit("receiveData", val);
    },
    pies() {
      let _this = this;
      var behaviorpie = this.$echarts.init(
        document.getElementById("echarts20")
      );
      let option = {
        color: ["#5F45FF", "#02CDFF", "#0190FF", "#314975"],
        title: {
          // text: '2016年12月长宁区合规成本分析'
        },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            // 坐标轴指示器，坐标轴触发有效
            type: "shadow" // 默认为直线，可选为：'line' | 'shadow'
          }
        },
        legend: {
          // show:true,
          data: _this.legendData20,
          right: 150,
          top: 30,
          icon: "circle",
          itemWidth: 8, // 图例图形宽度
          itemHeight: 8, // 图例图形高度
          textStyle: {
            color: ["#5F45FF", "#02CDFF", "#0190FF", "#314975"]
          }
        },
        grid: {
          top:"30%",
          left: "3%",
          right: "4%",
          bottom: "3%",
          containLabel: true
        },
        calculable: true,
        xAxis: [
          {
            type: "category",
            axisLabel: {
              textStyle: {
                fontSize: 12,
                color: "#000"
              }
            },
            axisLine: {
              lineStyle: {
                color: "#00A2FF",
                width: 2
              }
            },
            axisTick: {
              show: false
            },
            // splitLine: {
            //     lineStyle: {
            //         type: 'dashed',
            //         color: '#DDD'
            //     }
            // },
            data: _this.xData20
          }
        ],
        yAxis: [
          {
            type: "value",
            name: "(时间/小时)",
            color: "#000",
            nameTextStyle: {
              color: "#000",
              padding: [2, 0, 0, 20]
            },
            axisLabel: {
              formatter: "{value}",
              color: "#000",
              fontSize: 10
            },
            axisLine: {
              show: true,
              lineStyle: {}
            },
            axisTick: {
              //y轴刻度
              show: false
            },
            splitLine: {
              lineStyle: {
                type: "solid",
                color: "#324969"
              }
            }
          }
        ],
        series: [
          {
            name: _this.legendData20[0],
            type: "bar",
            barWidth: 8, //柱子宽度
            barGap: 0.5, //柱子之间间距
            itemStyle: {},
            data: _this.datagather[0]
          },
          {
            name: _this.legendData20[1],
            type: "bar",
            barWidth: 8, //柱子宽度
            barGap: 0.5, //柱子之间间距
            itemStyle: {},
            data: _this.datagather[1]
          },
          {
            name: _this.legendData20[2],
            type: "bar",
            barWidth: 8, //柱子宽度
            barGap: 0.5, //柱子之间间距
            itemStyle: {},
            data: _this.datagather[2]
          },
          {
            name: _this.legendData20[3],
            type: "bar",
            barWidth: 8, //柱子宽度
            barGap: 0.5, //柱子之间间距
            itemStyle: {},
            data: _this.datagather[3]
          }
        ]
      };
      behaviorpie.setOption(option);
    }
  }
};
</script>
<style scoped>

.tab-switch {
  height: 30px;
  position: absolute;
  right: 0;
  top: 24px;
}
.tab-switch span {
  color: #fff;
  font-size: 12px;
  text-align: center;
  width: 26px;
  padding: 3px;
  margin: 0px 10px;
  line-height: 18px;
  height: 18px;
  display: inline-block;
  background-color: #84A89C;
  border-radius: 5px;
}
.current {
  background: #07afa0 !important;
}
</style>


// WEBPACK FOOTER //
// src/components/xiayan/home/home/echarts12.vue